import React from 'react'

import { Bateau } from '~/icons/simulator/Bateau'
import { Benne } from '~/icons/simulator/Benne'
import { Bus } from '~/icons/simulator/Bus'
import { Camion } from '~/icons/simulator/Camion'
import { SuperCamion } from '~/icons/simulator/SuperCamion'
import { Camionette } from '~/icons/simulator/Camionette'
import { Train } from '~/icons/simulator/Train'
import { Transpalette } from '~/icons/simulator/Transpalette'
import { Voiture } from '~/icons/simulator/Voiture'

export const vehicleIcons = {
  transpalette: <Transpalette />,
  voiture: <Voiture />,
  camionette: <Camionette />,
  benne: <Benne />,
  camion: <Camion />,
  superCamion: <SuperCamion />,
  bus: <Bus />,
  bateau: <Bateau />,
  train: <Train />,
}

export const ignoredVehiclesInTable = ['benne']
